import React from "react";
import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, defaultBooleanField, mapAsOfSubtextDate } from "helpers/row-logic-helper";

import {
  shouldShowMonthlySub
  , shouldShowQuarterlySub
  , shouldShowSemiAnnuallySub
  , shouldShowAnnuallySub
  , shouldShowGuarantorDeliveryPeriodMonthly
  , shouldShowGuarantorDeliveryPeriodQuarterly
  , shouldShowGuarantorDeliveryPeriodSemiAnnually
  , shouldShowGuarantorDeliveryPeriodAnnually
  , shouldShowListOfDocsMonthly
  , shouldShowListOfDocsQuarterly
  , shouldShowListOfDocsSemiAnnually
  , shouldShowListOfDocsAnnually
  , shouldShowGuarantorDocsMonthly
  , shouldShowGuarantorDocsQuarterly
  , shouldShowGuarantorDocsSemiAnnually
  , shouldShowGuarantorDocsAnnually
  , shouldShowSignor
} from "./section-loan-guarantor-docs-row-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  monthlySubSection: {
    isVisible: loan => shouldShowMonthlySub(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "Monthly",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        className: "subsection",
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.covenants.guarantorDocsMonthly"
      }
    ]
  },

  calculationPeriodsMonthly: {
    isVisible: data => shouldShowGuarantorDeliveryPeriodMonthly(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Delivery Period (days)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.guarantorDeliveryPeriodMonthly"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  listOfDocsMonthly: {
    isVisible: data => shouldShowListOfDocsMonthly(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "List Of Docs",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => {
          const listOfDocs = defaultField(data, "covenants.guarantorListOfDocsMonthly");
          const list = listOfDocs.sort((a, b) => (`${a.name}`).localeCompare(b.name)).map(x => (<p>{x.name}</p>));
          if (list.length > 0) {
            return list;
          }

          return [];
        },
        Cell: tableSideColumnMapper
      }
    ]
  },

  guarantorDocsMonthly: {
    isVisible: data => shouldShowGuarantorDocsMonthly(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => mapAsOfSubtextDate(data, "covenants.guarantorDocsMonthlyReportingStart"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  quarterlySubSection: {
    isVisible: loan => shouldShowQuarterlySub(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "Quarterly",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        className: "subsection",
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.covenants.guarantorDocsQuarterly"
      }
    ]
  },

  guarantorDeliveryPeriodQuarterly: {
    isVisible: data => shouldShowGuarantorDeliveryPeriodQuarterly(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Delivery Period (days)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.guarantorDeliveryPeriodQuarterly"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  listOfDocsQuarterly: {
    isVisible: data => shouldShowListOfDocsQuarterly(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "List Of Docs",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => {
          const listOfDocs = defaultField(data, "covenants.guarantorListOfDocsQuarterly");
          const list = listOfDocs.sort((a, b) => (`${a.name}`).localeCompare(b.name)).map(x => (<p>{x.name}</p>));
          if (list.length > 0) {
            return list;
          }

          return [];
        },
        Cell: tableSideColumnMapper
      }
    ]
  },

  guarantorDocsQuarterly: {
    isVisible: data => shouldShowGuarantorDocsQuarterly(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => mapAsOfSubtextDate(data, "covenants.guarantorDocsQuarterlyReportingStart"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  semiAnnuallySubSection: {
    isVisible: loan => shouldShowSemiAnnuallySub(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "Semi-Annually",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        className: "subsection",
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.covenants.guarantorDocsSemiAnnually"
      }
    ]
  },

  guarantorDeliveryPeriodSemiAnnually: {
    isVisible: data => shouldShowGuarantorDeliveryPeriodSemiAnnually(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Delivery Period (days)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.guarantorDeliveryPeriodSemiAnnually"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  listOfDocsSemiAnnually: {
    isVisible: data => shouldShowListOfDocsSemiAnnually(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "List Of Docs",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => {
          const listOfDocs = defaultField(data, "covenants.guarantorListOfDocsSemiAnnually");
          const list = listOfDocs.sort((a, b) => (`${a.name}`).localeCompare(b.name)).map(x => (<p>{x.name}</p>));
          if (list.length > 0) {
            return list;
          }

          return [];
        },
        Cell: tableSideColumnMapper
      }
    ]
  },

  guarantorDocsSemiAnnually: {
    isVisible: data => shouldShowGuarantorDocsSemiAnnually(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => mapAsOfSubtextDate(data, "covenants.guarantorDocsSemiAnnuallyReportingStart"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  annuallySubSection: {
    isVisible: loan => shouldShowAnnuallySub(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "Annually",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        className: "subsection",
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.covenants.guarantorDocsAnnually"
      }
    ]
  },

  guarantorDeliveryPeriodAnnually: {
    isVisible: data => shouldShowGuarantorDeliveryPeriodAnnually(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Delivery Period (days)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.guarantorDeliveryPeriodAnnually"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  listOfDocsAnnually: {
    isVisible: data => shouldShowListOfDocsAnnually(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "List Of Docs",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => {
          const listOfDocs = defaultField(data, "covenants.guarantorListOfDocsAnnually");
          const list = listOfDocs.sort((a, b) => (`${a.name}`).localeCompare(b.name)).map(x => (<p>{x.name}</p>));
          if (list.length > 0) {
            return list;
          }

          return [];
        },
        Cell: tableSideColumnMapper
      }
    ]
  },

  guarantorDocsAnnually: {
    isVisible: data => shouldShowGuarantorDocsAnnually(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => mapAsOfSubtextDate(data, "covenants.guarantorDocsAnnuallyReportingStart"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  generalSubSection: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "General",
        Cell: tableSideColumnMapper,
        colSpan: 2
      }
    ]
  },

  guarantorOfficerCertificate: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Officer Certificate",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultBooleanField(data, "covenants.guarantorOfficerCertificate", "Required", "Not Required"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  signor: {
    isVisible: data => shouldShowSignor(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Signor",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.guarantorSignor.fullName"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
